<template>
  <div class="c-processing">
    <div class="c-processing__content c-processing__content--margin-bottom ">
      <p class="normal-text normal-text__important normal-text__last-justify">形成原因</p>
    </div>

    <div class="c-processing__content" v-for="(c, index) of content" :key="c.id">
      <p class="normal-text normal-text__last-justify">{{ c.t }}</p>
      <!-- extra text -->
      <p class="normal-text-small">{{ c.e }}</p>
      <p class="arrow-text" v-if="index !== content.length - 1">
        <span>↓</span>
        <span v-if="c.a">{{ c.a }}</span>
      </p>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Processing',
  props: {
    content: {
      type: Array,
      default: () => [],
    },
  },
});
</script>
<style lang="scss" scoped>
@import '@/styles/share/pureText.scss';

.c-processing {
  margin-bottom: 20px;

  &__content {
    @include flex(center, center, column);

    &--margin-bottom {
      margin-bottom: 20px;
    }
  }
}

.arrow-text {
  color: $c-main;
  text-align-last: center;
}
</style>
